export const ERROR_REQUEST_DEFAULT =
  "Что-то пошло не так при загрузке данных, попробуйте повторить позднее";
export const NO_SLOTS_ON_SELECTED_DATE =
  "К сожалению на выбранную дату нет доступных слотов для записи. Выберите другую дату или обратитесь в регистратуру клиники";
export const SELECT_DATE_SLOTS = "Для отображения слотов выберете дату";
export const DATA_LOAD_ERROR = "Ошибка загрузки данных";
